export default {
  title: 'Liefersoft',
  form: {
    company_id: 'Yrityksen tunnus',
    login: 'Kirjautumistunnus',
    password: 'Salasana',
  },
  buttons: {
    save: 'Tallenna',
    edit: 'Muokkaa',
    cancel: 'Peruuta',
  },
  toasts: {
    error: 'Muutosten tallentaminen epäonnistui',
    success: 'Muutokset tallennettiin',
  },
  instructions: {
    title: 'Käyttöönotto-ohjeet:',
    steps: {
      1: 'Siirry kohtaan ”Asetukset” > ”Ohjelman asetukset” > ”API/Rajapinnat.”',
      2: 'Lisää alusta:\n• Napsauta ”Alustat”-painiketta.\n• Syötä käyttäjätunnus (esim. alustan nimi).\n• Napsauta ”Tallenna”.',
      3: 'Kopioi API-tiedot:\n• Tallennuksen jälkeen näkyviin tulee ikkuna, jossa on API-alustan koodi.\n• Kopioi näkyvät tiedot.',
    },
  },
  connected: {
    title: 'Liefersoft on yhdistetty',
    description: 'Tämä integraatio on otettu käyttöön.',
  },
};
